const taxesUrl = '/taxes';
const settingsTaxesUrl = '/settings/taxes';
export default {
    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes
     */
    async getAllVat(offset = 0, shouldGetEmbed = false, shouldGetEcoTax = false) {
        const params = {
            order: 'rank',
            include_ecotax: shouldGetEcoTax,
            limit: 100,
            offset,
        };
        if (shouldGetEmbed) params.embed = ['acl', 'translations'];
        const taxesResult = [];
        let result = await ApiClient.get(taxesUrl, params);
        taxesResult.push(...result.data.data);
        while (taxesResult.length < result.data.pagination.total) {
            params.offset = taxesResult.length;
            result = await ApiClient.get(taxesUrl, params);
            taxesResult.push(...result.data.data);
        }
        return taxesResult;
    },

    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes settings for VatSettings.vue
     */
    getSettingsTaxes() {
        return ApiClient.get(settingsTaxesUrl);
    },

    /**
     *
     * @param {Array} taxes
     * @returns {Promise}
     * Update all taxes and fetch again to keep them sync with server
     */
    updateTaxes(taxes) {
        for (const tax of taxes) {
            tax.rate = Number(tax.rate);
            if (tax._embed) {
                //We don't want embed on post call
                delete tax._embed;
            }
            if (tax.is_ecotax) {
                delete tax.rate;
                delete tax.is_active;
            }
            tax.translations = [...tax.translations.filter((item) => item.value.trim())];
        }

        return new Promise((resolve, reject) =>
            ApiClient.post(`${taxesUrl}/batch`, {}, taxes)
                .then((response) => {
                    if (response.status !== 204) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                }),
        );
    },

    /**
     *
     * @param {Array} settingsTaxes
     * Update all settings for taxes
     */
    updateTaxesSettings(settingsTaxes) {
        return new Promise((resolve, reject) => {
            ApiClient.put(settingsTaxesUrl, {}, settingsTaxes)
                .then((response) => {
                    if (response.status !== 200) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
